import { render, staticRenderFns } from "./Form06.vue?vue&type=template&id=642f2224&scoped=true"
import script from "./Form06.vue?vue&type=script&lang=js"
export * from "./Form06.vue?vue&type=script&lang=js"
import style0 from "./Form06.vue?vue&type=style&index=0&id=642f2224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642f2224",
  null
  
)

export default component.exports